import React, {useEffect, useState} from 'react';
import "./Admins.css"
import notebook from "../../../Assets/Notebook.svg"
import AdminItem from "../AdminItem/AdminItem";
import Service from "../../../API/Service";
import MyBanner from "../MyBanner/MyBanner";
import SearchAndFilter from "../SearchAndFilter/SearchAndFilter";
import MyPagination from "../MyPagination/MyPagination";

const Admins = () => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [info, setInfo] = useState([]);
    const [filters, setFilters] = useState({
        isBlocked: "",
        searchText: ""
    });

    const entity = 'admins'
    const text = 'Are you sure you want to delete this admin? This action cannot be undone.'
    const title = 'Header of management page bla bla'
    const desc = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getUsers(entity, filters, page); // Передаём фильтры
                // console.log(response);
                const content = response.data.content;
                setInfo(content);
                setTotalPages(response.data.totalPages)
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
                setInfo([]);
            }
        };
        fetchData();
    }, [filters, page]);

    return (
        <div className={"wrp"}>
            <MyBanner
                background={"linear-gradient(117.3deg, #4E63E4 11.56%, #3D54E1 50.04%, #223CDD 110.24%)"}
                title={title}
                desc={desc}
                image={notebook}
                isBlue={false}
                entity={entity}
            />
            <div className={"main__block"}>
                <div className={"upper__part"}>
                    <SearchAndFilter
                        filters={filters}
                        setFilters={setFilters}
                        entity={entity}
                    />
                </div>
                <div className={"content"}>
                    {info.map((item, index) =>(
                        <AdminItem
                            key={index}
                            id={item.id}
                            entity={entity}
                            name={item.name}
                            surname={item.surname}
                            setData={setInfo}
                            text={text}
                        />
                    ))}

                </div>
                <MyPagination totalPages={totalPages} currentPage={page} onPageChange={setPage}/>
            </div>
        </div>
    );
};

export default Admins;